import React, { FC } from 'react';
import { GraphOverlay } from './GraphOverlay';
import { LaGraphToolbar } from './LaGraphToolbar';
import { QeGraphJson } from './QeGraphJson';
import { ResultsGraph } from './ResultsGraph';
import { ResultsLegend } from './ResultsLegend';
import { QeHighlightedPaths } from './QeHighlightedPaths';

interface Props {
  id: string;
}

export const Results: FC<Props> = ({ id }) => {
  const attrId = `${id}Results`;
  return (
    <React.Fragment>
      <div data-testid={attrId} data-cy={attrId} id="linkAnalysisResults">
        <LaGraphToolbar />
        <ResultsGraph id={id} />
        <ResultsLegend id={id} />
        <QeGraphJson />
        <QeHighlightedPaths />
      </div>
      <GraphOverlay />
    </React.Fragment>
  );
};
